export const no = {
  Advarsel: "Advarsel",
  Aksjonskort: "Aksjonskort",
  "Aktive infrastrukturhendelser": "Aktive infrastrukturhendelser",
  "Aktive stasjonshendelser": "Aktive stasjonshendelser",
  Alpha: "Alpha",
  "alle dager": "alle dager",
  "Alle dager": "Alle dager",
  "Alle dine endringer vil gå tapt. Det er ikke mulig å angre dette valget.":
    "Alle dine endringer vil gå tapt. Det er ikke mulig å angre dette valget.",
  Alle: "Alle",
  Alvorlighetsgrad: "Alvorlighetsgrad",
  "Andre feil": "Andre feil",
  "Ankom brudd: {{time}}": "Ankom brudd: {{time}}",
  Ankomst: "Ankomst",
  annenhver: "annenhver",
  Annonsert: "Annonsert",
  Anvisere: "Anvisere",
  Arbeidsliste: "Arbeidsliste",
  Avbryt: "Avbryt",
  Bekreft: "Bekreft",
  Avgang: "Avgang",
  Avmarker: "Avmarker",
  "Avmarker alle": "Avmarker alle",
  "Avmarker valgte": "Avmarker valgte",
  "Avstengt togsett": "Avstengt togsett",
  Avstigning: "Avstigning",
  "Avvik på": "Avvik på",

  "Bakre togsett": "Bakre togsett",
  "Behandle tog": "Behandle tog",
  "Behandle {{count}} tog": "Behandle {{count}} tog",
  "{{count}} tog": "{{count}} tog",
  "Behandles...": "Behandles...",
  Behandlet: "Behandlet",
  Beklager: "Beklager",
  "Beklager, men vi lyktes ikke med å koble til. Vennligst logg ut og prøv igjen.":
    "Beklager, men vi lyktes ikke med å koble til. Vennligst logg ut og prøv igjen.",
  Bemanning: "Bemanning",
  berørt: "berørt",
  Bravo: "Bravo",
  "Bruker ({{username}}) er ikke registrert i Puzzel. Ta kontakt med admin":
    "Bruker ({{username}}) er ikke registrert i Puzzel. Ta kontakt med admin",
  "Beskriv hendelsen og årsaken kortfattet og tydelig.":
    "Beskriv hendelsen og årsaken kortfattet og tydelig.",
  Buss: "Buss",

  Charlie: "Charlie",
  "{{count}} brudd_other": "{{count}} brudd",
  "{{count}} brudd": "{{count}} brudd",
  "{{count}} tog valgt": "{{count}} tog valgt",

  Dato: "Dato",
  Dekning: "Dekning",
  "Del med": "Del med",
  "Marker med": "Marker med",
  "Marker som": "Marker som",
  Delta: "Delta",
  Depubliser: "Depubliser",
  depublisere: "depublisere",
  Depublisert: "Depublisert",
  "Dersom feilen er gjentakende, send gjerne en liten beskrivelse om hvordan du gikk frem da feilen oppsto":
    "Dersom feilen er gjentakende, send gjerne en liten beskrivelse om hvordan du gikk frem da feilen oppsto",
  "Det er ikke registrert noen fremtidige hendelser":
    "Det er ikke registrert noen fremtidige hendelser",
  "Det er ingen behandlede tog for øyeblikket":
    "Det er ingen behandlede tog for øyeblikket",
  "Det er ingen ikke berørte tog for øyeblikket":
    "Det er ingen ikke berørte tog for øyeblikket",
  "Det er ingen ubehandlede tog for øyeblikket":
    "Det er ingen ubehandlede tog for øyeblikket",
  "Det er problemer med tilkoblingen til serveren. Vennligst kontroller din nettverksforbindelse, eller last inn siden på nytt.":
    "Det er problemer med tilkoblingen til serveren. Vennligst kontroller din nettverksforbindelse, eller last inn siden på nytt.",
  "Dette er en oppsummering av informasjon som sendes ut om denne hendelsen. Ordlyden tilpasses etter mottaker.":
    "Dette er en oppsummering av informasjon som sendes ut om denne hendelsen. Ordlyden tilpasses etter mottaker.",
  "Dette toget eksisterer allerede i et annet produksjonsavvik i valgt periode":
    "Dette toget eksisterer allerede i et annet produksjonsavvik i valgt periode",
  "Din økt har utløpt. Vennligst logg inn på nytt for å fortsette.":
    "Din økt har utløpt. Vennligst logg inn på nytt for å fortsette.",
  "Det finnes ikke passeringsmeldinger for dette stoppet":
    "Det finnes ikke passeringsmeldinger for dette stoppet",
  Distribusjon: "Distribusjon",
  "Drops Dashboard": "Drops Dashboard",
  "Drops Dashbord får ikke kontakt med tjener. Dette kan skyldes nettverksproblemer.":
    "Drops Dashbord får ikke kontakt med tjener. Dette kan skyldes nettverksproblemer.",
  "Du har endret infrastrukturhendelsen på en måte som kanskje påvirker den globale meldingen":
    "Du har endret infrastrukturhendelsen på en måte som kanskje påvirker den globale meldingen",
  "Opprett nytt avvik for å endre periode eller hendelsetype.":
    "Opprett nytt avvik for å endre periode eller hendelsetype.",
  "Du har ikke tilgang til Drops Dashboard":
    "Du har ikke tilgang til Drops Dashboard",
  "Skriv inn tekst her...": "Skriv inn tekst her...",
  "Dyrefri vogn": "Dyrefri vogn",
  "Dyr tillatt vogn": "Dyr tillatt vogn",

  "Egendefinert hendelse": "Egendefinert hendelse",
  "Eksempel: Eksterne kanaler": "Eksempel: Eksterne kanaler",
  "Eksempel: Interne kanaler": "Eksempel: Interne kanaler",
  "Ekstra stasjon": "Ekstra stasjon",
  Endre: "Endre",
  "Endre strekning": "Endre strekning",
  "Endre strekningsnavn*": "Endre strekningsnavn*",
  "En feil har oppstått": "En feil har oppstått",
  "Engelsk beskrivelse": "Engelsk beskrivelse",
  "Engelsk tekst": "Engelsk tekst",
  "Engelsk tittel": "Engelsk tittel",
  "Enkelte funksjoner er ikke brukbare, men det finnes midlertidige løsninger. Mail sendes kun til Team DROPS, og besvares innen normal arbeidstid.":
    "Enkelte funksjoner er ikke brukbare, men det finnes midlertidige løsninger. Mail sendes kun til Team DROPS, og besvares innen normal arbeidstid.",
  "Er du sikker?": "Er du sikker?",
  "Er du sikker på at du vil": "Er du sikker på at du vil",
  "Er du sikker på at du vil friskmelde følgende tog?":
    "Er du sikker på at du vil friskmelde følgende tog?",
  "Er i produksjonsavvik": "Er i produksjonsavvik",
  Erstattet: "Erstattet",
  "Estimert antall passasjerer": "Estimert antall passasjerer",

  Familievogn: "Familievogn",
  "Fant ingen informasjon om bemanning på dette toget.":
    "Fant ingen informasjon om bemanning på dette toget.",
  "Fant ingen informasjon om togsammensetning.":
    "Fant ingen informasjon om togsammensetning.",
  "Fant ingen operative tog for øyeblikket":
    "Fant ingen operative tog for øyeblikket",
  "Fant ingen registrerte hendelser på dette toget.":
    "Fant ingen registrerte hendelser på dette toget.",
  "Fant ingen rute for dette toget.": "Fant ingen rute for dette toget.",
  "Feil i DROPS Dashboard": "Feil i DROPS Dashboard",
  "Oppdater siden for å gå tilbake": "Oppdater siden for å gå tilbake",
  Filter: "Filter",
  "Filteret gir ingen treff": "Filteret gir ingen treff",
  "Filtrer på:": "Filtrer på:",
  "Ny melding": "Ny melding",
  "Ny to-do": "Ny to-do",
  Send: "Send",
  "Send også til To-do": "Send også til To-do",
  "Filtrér på strekning og togserie:": "Filtrér på strekning og togserie:",
  "Filtrér på strekning eller togserie(r)":
    "Filtrér på strekning eller togserie(r)",
  "Fjern filter": "Fjern filter",
  "Fjern filtre": "Fjern filtre",
  "Fjern valgte": "Fjern valgte",
  "For område": "For område",
  "Forsinkelse forventes": "Forsinkelse forventes",
  "Forsinkelse (min)": "Forsinkelse (min)",
  Forsinket: "Forsinket",
  "For togserien_one": "For togserien",
  "For togserien_other": "For togseriene",
  "Forventet forsinkelse (min)": "Forventet forsinkelse (min)",
  fra: "fra",
  Fra: "Fra",
  "Fra dato": "Fra dato",
  "Fra kl": "Fra kl",
  "Fra og med stasjon*": "Fra og med stasjon*",
  "Fra stasjon*": "Fra stasjon*",
  fre: "fre",
  "Fremre togsett": "Fremre togsett",
  Fremtidige: "Fremtidige",
  "Fremtidige hendelser": "Fremtidige hendelser",
  Friskmeld: "Friskmeld",
  "Friskmeld {{count}} tog": "Friskmeld {{count}} tog",
  friskmelde: "friskmelde",
  Friskmeldt: "Friskmeldt",
  "Friskmeld tog": "Friskmeld tog",
  "Fungerende toaletter": "Fungerende toaletter",
  "Funksjoner er ikke brukbare og arbeidet stopper opp. Mail sendes til både Team DROPS og IT Servicesenter, og besvares fortløpende innen normal arbeidstid.":
    "Funksjoner er ikke brukbare og arbeidet stopper opp. Mail sendes til både Team DROPS og IT Servicesenter, og besvares fortløpende innen normal arbeidstid.",
  "Fyll ut obligatoriske felter for å se informasjonen.":
    "Fyll ut obligatoriske felter for å se informasjonen.",
  "Følgende stopp er allerede innstilt:":
    "Følgende stopp er allerede innstilt:",
  "Får ikke kontakt med tjener": "Får ikke kontakt med tjener",

  "Gammel kapasitet": "Gammel kapasitet",
  "Gammel rute:": "Gammel rute:",
  "Generell informasjon": "Generell informasjon",
  "Gjeldende tog": "Gjeldende tog",
  Gjentas: "Gjentas",
  Gjenåpne: "Gjenåpne",
  "Gjenåpne hendelse": "Gjenåpne hendelse",
  Global: "Global",
  "Global driftsmelding": "Global driftsmelding",
  Globale: "Globale",
  "Global hendelse": "Global hendelse",
  "Gruppereise/assistanse": "Gruppereise/assistanse",
  Gul: "Gul",
  "Gå en dag frem": "Gå en dag frem",
  "Gå en dag tilbake": "Gå en dag tilbake",
  Handling: "Handling",
  "Hei Team Brukerflater Drops": "Hei Team Brukerflater Drops",
  hendelse: "hendelse",
  Hendelse_one: "Hendelse",
  Hendelse_other: "Hendelser",
  "Hendelse endret": "Hendelse endret",
  "hendelsen?": "hendelsen?",
  "Hendelsene kan redigeres eller friskmeldes fra ":
    "Hendelsene kan redigeres eller friskmeldes fra ",
  "Hendelsen er aktiv mellom": "Hendelsen er aktiv mellom",
  "Hendelsen inneholder egendefinert tekst. Sjekk at oppsummeringen ser riktig ut før du går videre.":
    "Hendelsen inneholder egendefinert tekst. Sjekk at oppsummeringen ser riktig ut før du går videre.",
  "Hendelsen inneholder egendefinert tekst. Sjekk at beskrivelsen ser riktig ut før du går videre.":
    "Hendelsen inneholder egendefinert tekst. Sjekk at beskrivelsen ser riktig ut før du går videre.",
  "Hendelse opprettet": "Hendelse opprettet",
  "Hele landet": "Hele landet",
  "Hele toget": "Hele toget",
  "Hel strekning": "Hel strekning",
  her: "her",
  Holdeplass: "Holdeplass",
  "Hva forventet du skulle skje?": "Hva forventet du skulle skje?",
  "Hva gjorde du? Beskriv kort stegene frem til feilen oppstod slik at vi kan reprodusere det.":
    "Hva gjorde du? Beskriv kort stegene frem til feilen oppstod slik at vi kan reprodusere det.",
  "Hva skjedde, og hvor i Dashboard?": "Hva skjedde, og hvor i Dashboard?",
  hver: "hver",
  "Hver uke": "Hver uke",
  "Hver 2. uke": "Hver 2. uke",
  Hvile: "Hvile",
  "hvis feilen vedvarer.": "hvis feilen vedvarer.",
  Høyttalere: "Høyttalere",

  "i dag": "i dag",
  "i går": "i går",
  "Ikke berørt": "Ikke berørt",
  "ikke berørt": "ikke berørt",
  "Ikke fra samme brudd som valgte tog": "Ikke fra samme brudd som valgte tog",
  "Ikke valgt": "Ikke valgt",
  "i morgen": "i morgen",
  Informasjon: "Informasjon",
  "Informasjon som sendes ut": "Informasjon som sendes ut",
  Infrastruktur: "Infrastruktur",
  infrastrukturhendelse: "infrastrukturhendelse",
  Infrastrukturhendelse: "Infrastrukturhendelse",
  Infrastrukturleverandør: "Infrastrukturleverandør",
  "Ingen handling valgt": "Ingen handling valgt",
  "Ingen omkjøringer finnes": "Ingen omkjøringer finnes",
  "Ingen passeringsmeldinger for dette stoppet.":
    "Ingen passeringsmeldinger for dette stoppet.",
  "Ingen rolle": "Ingen rolle",
  "Ingen tog som kjører i valgt tidsperiode":
    "Ingen tog som kjører i valgt tidsperiode",
  "Ingen treff": "Ingen treff",
  "Ingen årsak": "Ingen årsak",
  Innstilt: "Innstilt",
  "Innstilt fra {{infrastructureProvider}}":
    "Innstilt fra {{infrastructureProvider}}",
  "Innstilt på stopp": "Innstilt på stopp",
  "Interne meldinger": "Interne meldinger",
  "Intern melding": "Intern melding",
  "I-sirk": "I-sirk",
  "I tidsrommet": "I tidsrommet",

  "Ja, depubliser": "Ja, depubliser",
  "Ja, forkast": "Ja, forkast",
  "Ja, friskmeld": "Ja, friskmeld",

  Kafévogn: "Kafévogn",
  "Kan ikke depublisere allerede usynlig hendelse":
    "Kan ikke depublisere allerede usynlig hendelse",
  Kiosk: "Kiosk",
  "(Kilde: {{source}})": "(Kilde: {{source}})",
  Kode: "Kode",
  "Knytt hendelse til infrastrukturhendelse":
    "Knytt hendelse til infrastrukturhendelse",
  "Komplett kiosk": "Komplett kiosk",
  Kond: "Kond",
  "kontakt Brukerflater DROPS": "kontakt Brukerflater DROPS",
  Konsekvens: "Konsekvens",
  "Kontrollér opprinnelig strekning i strekningsnavn":
    "Kontrollér opprinnelig strekning i strekningsnavn",
  "Kopiér telefonnummer": "Kopiér telefonnummer",
  "Kopierte {{string}} til utklippstavlen.":
    "Kopierte {{string}} til utklippstavlen.",
  Kort: "Kort",
  "Kritisk feil": "Kritisk feil",
  "Kritisk feil i DROPS Dashboard": "Kritisk feil i DROPS Dashboard",
  "Kunne ikke depublisere hendelsen": "Kunne ikke depublisere hendelsen",
  "Kunne ikke endre hendelse.": "Kunne ikke endre hendelse.",
  "Kunne ikke endre produksjonsavvik.": "Kunne ikke endre produksjonsavvik.",
  "Kunne ikke finne distribusjonstekst": "Kunne ikke finne distribusjonstekst",
  "Kunne ikke friskmelde hendelsen": "Kunne ikke friskmelde hendelsen",
  "Kunne ikke hente berørte tog for enkelte hendelser":
    "Kunne ikke hente berørte tog for enkelte hendelser",
  "Kunne ikke hente berørte tog for hendelsen":
    "Kunne ikke hente berørte tog for hendelsen",
  "Kunne ikke hente data for ytterligere {{count}} hendelser_one":
    "Kunne ikke hente data for ytterligere {{count}} hendelse.",
  "Kunne ikke hente data for ytterligere {{count}} hendelser_other":
    "Kunne ikke hente data for ytterligere {{count}} hendelser.",
  "Kunne ikke hente global driftsmelding":
    "Kunne ikke hente global driftsmelding",
  "Kunne ikke hente hendelser for stasjon.":
    "Kunne ikke hente hendelser for stasjon.",
  "Kunne ikke hente mottakere fra Operational Text-tjenesten":
    "Kunne ikke hente mottakere fra Operational Text-tjenesten",
  "Kunne ikke hente oppsummering.": "Kunne ikke hente oppsummering.",
  "Kunne ikke hente rutedata. Listen med omkjøringer blir ikke filtrert automatisk. Pass på at du velger riktig omkjøring.":
    "Kunne ikke hente rutedata. Listen med omkjøringer blir ikke filtrert automatisk. Pass på at du velger riktig omkjøring.",
  "Kunne ikke hente ut stoppene til toget.":
    "Kunne ikke hente ut stoppene til toget.",
  "Kunne ikke hente tognummer eller dato for dette toget.":
    "Kunne ikke hente tognummer eller dato for dette toget.",
  "Kunne ikke kopiere til utklippstavlen. Vennligst prøv igjen.":
    "Kunne ikke kopiere til utklippstavlen. Vennligst prøv igjen.",
  "Kunne ikke markere som ": "Kunne ikke markere som ",
  "Kunne ikke opprette hendelse.": "Kunne ikke opprette hendelse.",
  "Kunne ikke opprette produksjonsavvik.":
    "Kunne ikke opprette produksjonsavvik.",
  Kundeveiledere: "Kundeveiledere",
  "Antall kundeveiledere som er anbefalt å sette inn på stasjoner påvirket av bruddet. Antallet er definert i tiltakskortet.":
    "Antall kundeveiledere som er anbefalt å sette inn på stasjoner påvirket av bruddet. Antallet er definert i tiltakskortet.",
  Kupé: "Kupé",

  "Lagre regel": "Lagre regel",
  Land: "Land",
  "Last på nytt": "Last på nytt",
  "Laster innhold": "Laster innhold",
  "Laster...": "Laster...",
  "laste siden": "laste siden",
  "Legg inn dine detaljer her": "Legg inn dine detaljer her",
  "Legg til regel": "Legg til regel",
  Lenker: "Lenker",
  "Likevel berørt": "Likevel berørt",
  "Logg inn": "Logg inn",
  "Logg ut": "Logg ut",
  "Logg ut av Dashboard": "Logg ut av Dashboard",
  Lok: "Lok",
  "Lok / Kond": "Lok / Kond",
  "Lok og vogn": "Lok og vogn",
  Lukk: "Lukk",
  "Lukk alle": "Lukk alle",
  lør: "lør",

  man: "man",
  "Marker alle": "Marker alle",
  "Marker alle tog": "Marker alle tog",
  "Marker tog i listen under": "Marker tog i listen under",
  "Manglende betalingsvalg": "Manglende betalingsvalg",
  "mangler utfylling": "mangler utfylling",
  "Mangler utfylling": "Mangler utfylling",
  MaxiTaxi: "MaxiTaxi",
  "Mellom kl {{startTime}} og {{endTime}}, {{days}}":
    "Mellom kl {{startTime}} og {{endTime}}, {{days}}",
  "Mellom stasjoner": "Mellom stasjoner",
  min: "min",
  Minibuss: "Minibuss",
  "min forsinket": "min forsinket",
  "min for tidlig": "min for tidlig",
  Monitorer: "Monitorer",
  Mottakere: "Mottakere",
  Mynt: "Mynt",
  "Mørk modus": "Mørk modus",
  "Må behandles": "Må behandles",
  "Målt antall passasjerer": "Målt antall passasjerer",
  "NB! Ønsker og innspill deles med fagansvarlig i avd. som tar det videre til produkteier og utviklerteam.":
    "NB! Ønsker og innspill deles med fagansvarlig i avd. som tar det videre til produkteier og utviklerteam.",
  "Nei, behold": "Nei, behold",
  Neste: "Neste",
  "Neste togserie": "Neste togserie",
  "Nettverksfeil i Dashboard": "Nettverksfeil i Dashboard",
  "Noe gikk galt under innlogging. Forsøk å":
    "Noe gikk galt under innlogging. Forsøk å",
  "Noe gikk galt! Last på nytt eller ": "Noe gikk galt! Last på nytt eller ",
  "Noe gikk galt! Last på nytt eller kontakt IT.":
    "Noe gikk galt! Last på nytt eller kontakt IT.",
  "Noe gikk galt ved henting av hendelser, aksjonskort, årsaker og konsekvenser. Last siden på nytt for å prøve igjen. Ta kontakt med IT hvis feilen vedvarer.":
    "Noe gikk galt ved henting av hendelser, aksjonskort, årsaker og konsekvenser. Last siden på nytt for å prøve igjen. Ta kontakt med IT hvis feilen vedvarer.",
  "Noe gikk galt ved henting av prognoser. Last siden på nytt for å prøve igjen. Ta kontakt med IT hvis feilen vedvarer.":
    "Noe gikk galt ved henting av prognoser. Last siden på nytt for å prøve igjen. Ta kontakt med IT hvis feilen vedvarer.",
  "Noe gikk galt ved lasting av innhold.":
    "Noe gikk galt ved lasting av innhold.",
  "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ":
    "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ",
  "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Ta kontakt med IT":
    "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Ta kontakt med IT",
  "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ta kontakt med IT.":
    "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ta kontakt med IT.",
  "Noe gikk galt, vennligst prøv igjen": "Noe gikk galt, vennligst prøv igjen",
  "Noen tog i serien(e) kjører ulike traseer":
    "Noen tog i serien(e) kjører ulike traseer",
  "Noen tog i samme serie kjører i ulike traséer. Sjekk at du velger riktige tog til behandling:":
    "Noen tog i samme serie kjører i ulike traséer. Sjekk at du velger riktige tog til behandling:",
  "Sjekk at du velger riktige tog": "Sjekk at du velger riktige tog",
  "Sjekk at du velger riktige tog til behandling.":
    "Sjekk at du velger riktige tog til behandling.",
  "Noen valgte tog kjører ulike traseer. Sjekk at du velger riktige tog til behandling.":
    "Noen valgte tog kjører ulike traseer. Sjekk at du velger riktige tog til behandling.",
  "Noe gikk galt! Last siden på nytt. Ev. kontakt Team Drops.":
    "Noe gikk galt! Last siden på nytt. Ev. kontakt Team Drops.",
  "Noe gikk galt! Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ta kontakt med team DROPS.":
    "Noe gikk galt! Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ta kontakt med team DROPS.",
  "Noe gikk galt! Last siden på nytt. Om feilen vedvarer, kontakt team DROPS via tilbakemeldingsknappene.":
    "Noe gikk galt! Last siden på nytt. Om feilen vedvarer, kontakt team DROPS via tilbakemeldingsknappene.",

  Norge: "Norge",
  Norsk: "Norsk",
  "Norsk beskrivelse": "Norsk beskrivelse",
  "Norsk tekst": "Norsk tekst",
  "Norsk tittel": "Norsk tittel",
  "Nullstill søk": "Nullstill søk",
  "Ny hendelse": "Ny hendelse",
  "Ny kapasitet": "Ny kapasitet",
  "Ny rute": "Ny rute",
  "Når skjedde det? Har det skjedd flere ganger?":
    "Når skjedde det? Har det skjedd flere ganger?",

  "og type hendelse": "og type hendelse",
  ons: "ons",
  "Oisann! Her mangler det data for hendelsen.":
    "Oisann! Her mangler det data for hendelsen.",
  "Oisann! Her var visst ingen kundeveiledere satt opp.":
    "Oisann! Her var visst ingen kundeveiledere satt opp.",
  Operativt: "Operativt",
  Opprett: "Opprett",
  "Opprettet av": "Opprettet av",
  "Opprett hendelse for": "Opprett hendelse for",
  Oppstått: "Oppstått",
  Oppsummering: "Oppsummering",
  Oversikt: "Oversikt",
  "Oversikt hendelser": "Oversikt hendelser",

  "Passerer gjennom": "Passerer gjennom",
  "Passerte brudd: {{time}}": "Passerte brudd: {{time}}",
  "(planlagt)": "(planlagt)",
  Planlagt: "Planlagt",
  "Planlagte hendelser": "Planlagte hendelser",
  Pluss: "Pluss",
  PlussNatt: "PlussNatt",
  Preferanser: "Preferanser",
  Produksjonsavvik: "Produksjonsavvik",
  produksjonsavvik: "produksjonsavvik",
  "Produksjonsavvik endret": "Produksjonsavvik endret",
  "Produksjonsavvik opprettet": "Produksjonsavvik opprettet",
  "Produkter som mangler:": "Produkter som mangler:",
  "Produkt mangler": "Produkt mangler",
  Prognose: "Prognose",
  "Prøver igjen... Forsøk {{attemptNumber}}/5":
    "Prøver igjen... Forsøk {{attemptNumber}}/5",
  "Prøver igjen om {{cooldownRemaining}} sekunder... Forsøk {{attemptNumber}}/5":
    "Prøver igjen om {{cooldownRemaining}} sekunder... Forsøk {{attemptNumber}}/5",
  "Prøv igjen": "Prøv igjen",
  "Prøv på nytt": "Prøv på nytt",
  "Prøv på nytt, eller kontakt IT hvis feilen vedvarer.":
    "Prøv på nytt, eller kontakt IT hvis feilen vedvarer.",
  på: "på",
  "på nytt, eller": "på nytt, eller",
  "På stasjon": "På stasjon",
  Påstigning: "Påstigning",
  "Påvirkede stasjoner": "Påvirkede stasjoner",
  "Påvirker direkte": "Påvirker direkte",

  Rediger: "Rediger",
  "Rediger regel": "Rediger regel",
  "Redusert kapasitet": "Redusert kapasitet",
  Reservebuss: "Reservebuss",
  Rolle: "Rolle",
  Rød: "Rød",

  "Samme trasé er valgt i en annen hendelse":
    "Samme trasé er valgt i en annen hendelse",
  Seddel: "Seddel",
  "Se detaljer": "Se detaljer",
  Selskap: "Selskap",
  "Sent satt opp": "Sent satt opp",
  "Se oppsummering": "Se oppsummering",
  "Siste tekst": "Siste tekst",
  "Skjul togliste": "Skjul togliste",
  "Slett regel": "Slett regel",
  Sluttdato: "Sluttdato",
  Sluttidspunkt: "Sluttidspunkt",
  Sovevogn: "Sovevogn",
  "Spesifikt tidspunkt": "Spesifikt tidspunkt",
  Spor: "Spor",
  Språk: "Språk",
  Startdato: "Startdato",
  Starttidspunkt: "Starttidspunkt",
  Stasjon: "Stasjon",
  Stasjonshendelse: "Stasjonshendelse",
  stasjonshendelse: "stasjonshendelse",
  Stasjonsvalg: "Stasjonsvalg",
  Stille: "Stille",
  Stopper: "Stopper",
  "Stopper ekstra": "Stopper ekstra",
  "Stopp på valgt strekning er allerede innstilt":
    "Stopp på valgt strekning er allerede innstilt",
  "Strekning:": "Strekning:",
  Svensk: "Svensk",
  "Svensk tekst": "Svensk tekst",
  "Svensk tittel": "Svensk tittel",
  Sverige: "Sverige",
  Sykkelplass: "Sykkelplass",
  Synlig: "Synlig",
  Synlighet: "Synlighet",
  "Systemet kan ikke brukes eller arbeidet stopper":
    "Systemet kan ikke brukes eller arbeidet stopper",
  "Tid fra": "Tid fra",
  "Tid til": "Tid til",
  "Synlig nå": "Synlig nå",
  Søk: "Søk",
  "Søk etter tognr., stasjon eller stikkord":
    "Søk etter tognr., stasjon eller stikkord",
  "Søk på skiftnr, stasjon eller tlfnr": "Søk på skiftnr, stasjon eller tlfnr",
  "Søk på skiftnr, stasjon, tlfnr eller tognr":
    "Søk på skiftnr, stasjon, tlfnr eller tognr",
  "Søk på tognummer": "Søk på tognummer",
  "Søk på tognr, stasjon, linjenr eller sett-ID":
    "Søk på tognr, stasjon, linjenr eller sett-ID",
  "Søk etter strekning, type hendelse...":
    "Søk etter strekning, type hendelse...",
  søn: "søn",

  "Kontakt IT": "Kontakt IT",
  "Ta kontakt med din nærmeste leder dersom du har behov for tilgang.":
    "Ta kontakt med din nærmeste leder dersom du har behov for tilgang.",
  "ta kontakt med IT": "ta kontakt med IT",
  "ta kontakt med IT.": "ta kontakt med IT.",
  "Takk for hjelpen! Vi besvarer mailen fortløpende innen normale arbeidstider.":
    "Takk for hjelpen! Vi besvarer mailen fortløpende innen normale arbeidstider.",
  "Takk for hjelpen! Vi besvarer mailen innen normale arbeidstider.":
    "Takk for hjelpen! Vi besvarer mailen innen normale arbeidstider.",
  Taxi: "Taxi",
  "Tekniske detaljer": "Tekniske detaljer",
  Tid: "Tid",
  "Tid til brudd: {{time}}": "Tid til brudd: {{time}}",
  "Tidene kan avvike litt avhengig av datagrunnlag":
    "Tidene kan avvike litt avhengig av datagrunnlag",
  Tidshorisont: "Tidshorisont",
  "Tidshorisont i min.": "Tidshorisont i min.",
  Tidsperiode: "Tidsperiode",
  til: "til",
  Til: "Til",
  "Til dato": "Til dato",
  Tilbake: "Tilbake",
  Tilbakemelding: "Tilbakemelding",
  Tilbakemeldinger: "Tilbakemeldinger",
  "Tilbakemelding fra Drops Dashboard": "Tilbakemelding fra Drops Dashboard",
  "Tilbakestill filter": "Tilbakestill filter",
  "Til kl": "Til kl",
  "Tilknyttet hendelse": "Tilknyttet hendelse",
  "Tilknyttet stasjoner": "Tilknyttet stasjoner",
  "Tilknyttet tog": "Tilknyttet tog",
  "Til og med stasjon*": "Til og med stasjon*",
  Tilstand: "Tilstand",
  "Til stasjon*": "Til stasjon*",
  tir: "tir",
  Tjenestevarsling: "Tjenestevarsling",
  Tognr: "Tognr",
  Tidspunkt: "Tidspunkt",
  Tog: "Tog",
  Togtype: "Togtype",
  Status: "Status",
  "Nullstill filter": "Nullstill filter",
  "Nullstill filtre": "Nullstill filtre",
  "Vis fullførte": "Vis fullførte",
  "Vis fullførte oppgaver": "Vis fullførte oppgaver",
  "Toget har allerede passert stasjonen.":
    "Toget har allerede passert stasjonen.",
  Toghendelse: "Toghendelse",
  toghendelse: "toghendelse",
  Togkart: "Togkart",
  Togliste: "Togliste",
  Togserie: "Togserie",
  tor: "tor",
  Trasé: "Trasé",
  treff: "treff",
  Trusselnivå: "Trusselnivå",
  "Trådløst internett": "Trådløst internett",
  "Tøm søkefeltet for å bruke tidsvelgeren":
    "Tøm søkefeltet for å bruke tidsvelgeren",
  Type: "Type",

  Ubehandlet: "Ubehandlet",
  "Ukjent kjøretøy": "Ukjent kjøretøy",
  uke: "uke",
  "Ukjent navn": "Ukjent navn",
  Usynlig: "Usynlig",
  "Utgangstid (min)": "Utgangstid (min)",
  Utgått: "Utgått",

  "Valgte tog i serien:": "Valgte tog i serien:",
  "Valgt togserie_one": "Valgt togserie",
  "Valgt togserie_other": "Valgte togserier",
  "Legg gjerne ved et skjermbilde av hele skjermen (Windows + Shift + S).":
    "Legg gjerne ved et skjermbilde av hele skjermen (Windows + Shift + S).",
  "Velg alle": "Velg alle",
  "Velg alle tog": "Velg alle tog",
  "Velg annen på stasjon-stopp enn siste stopp":
    'Velg annen "på stasjon"-stopp enn siste stopp',
  "Velg berørte tog for togserie": "Velg berørte tog for togserie",
  "Vis berørte tog": "Vis berørte tog",
  "Skjul berørte tog": "Skjul berørte tog",
  "Sist oppdatert:": "Sist oppdatert:",
  "Velg berørte togserier": "Velg berørte togserier",
  "Berørte togserier": "Berørte togserier",
  "Se alle togserier": "Se alle togserier",
  "Ingen tog i valgt periode": "Ingen tog i valgt periode",
  "Velg en gyldig tidsperiode for å se tilgjengelige togserier":
    "Velg en gyldig tidsperiode for å se tilgjengelige togserier",
  "Velg dato": "Velg dato",
  "Åpne kalender": "Åpne kalender",
  "Velg en": "Velg en",
  "Velg en infrastrukturhendelse": "Velg en infrastrukturhendelse",
  "Velg en strekning": "Velg en strekning",
  "Velg hvor produktene mangler": "Velg hvor produktene mangler",
  "Velg nivå": "Velg nivå",
  "Velg omkjøringer:": "Velg omkjøringer:",
  "Velg påvirkede systemer": "Velg påvirkede systemer",
  "Velg stasjon": "Velg stasjon",
  "Velg trusselnivå": "Velg trusselnivå",
  "Vennligst ta kontakt med IT": "Vennligst ta kontakt med IT",
  Versjon: "Versjon",
  Versjonsdato: "Versjonsdato",
  via: "via",
  "Viktig funksjon fungerer ikke, men det finnes en midlertidig løsning.":
    "Viktig funksjon fungerer ikke, men det finnes en midlertidig løsning.",
  "Vil du forkaste endringene?": "Vil du forkaste endringene?",
  Vis: "Vis",
  "Vis alle": "Vis alle",
  "Viser {{count}} av {{total}}": "Viser {{count}} av {{total}}",
  "Vis frem i tid": "Vis frem i tid",
  "Vis lukkede": "Vis lukkede",
  "Vis mindre": "Vis mindre",
  "Vis tog med manglende data": "Vis tog med manglende data",
  "Vis passerte tog": "Vis passerte tog",
  "Vis skjulte": "Vis skjulte",
  "Vis slettede": "Vis slettede",
  Vogner: "Vogner",
  VY: "VY",
  VYT: "VYT",

  "Økt kapasitet": "Økt kapasitet",
  Øvrige: "Øvrige",

  Åpen: "Åpen",
  Årsak: "Årsak",
};
